/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Skeleton, Result, Button } from 'antd';
import Overlay from '../../../../common/Overlay';
import { useResponsive } from 'hooks/useResponsive';
import { useNavigationContext } from '@app/contexts/NavigationContext';
import * as S from './MainSider.styles';
import { SiderLogo } from '../SiderLogo';
import SiderMenu from '../SiderMenu/SiderMenu';

interface MainSiderProps {
  isCollapsed: boolean;
  setCollapsed: (isCollapsed: boolean) => void;
}

const MainSider: React.FC<MainSiderProps> = ({
  isCollapsed,
  setCollapsed,
  ...props
}) => {
  /* ─ responsividade ──────────────────────────────────────────────── */
  const { isDesktop, mobileOnly } = useResponsive();
  const isCollapsible = !isDesktop;
  const toggleSider = () => setCollapsed(!isCollapsed);

  /* ─ navegação dinâmica ──────────────────────────────────────────── */
  const { navigation, loading, error, refetch } = useNavigationContext();

  /* ─ render helper p/ área do menu ───────────────────────────────── */
  const renderContent = () => {
    if (loading) {
      return (
        <Skeleton
          active
          title={false}
          paragraph={{ rows: 8, width: '80%' }}
          style={{ padding: '1rem' }}
        />
      );
    }

    if (error) {
      return (
        <Result
          status="warning"
          title="Erro ao carregar menu"
          subTitle={error}
          extra={
            <Button type="primary" onClick={refetch}>
              Tentar novamente
            </Button>
          }
        />
      );
    }

    return (
      <SiderMenu
        items={navigation}
        setCollapsed={setCollapsed}
        isCollapsed={!isDesktop && isCollapsed}
      />
    );
  };

  return (
    <>
      <S.Sider
        trigger={null}
        collapsed={!isDesktop && isCollapsed}
        collapsedWidth={0}
        collapsible={isCollapsible}
        width={260}
        {...props}
      >
        <SiderLogo
          isSiderCollapsed={!isDesktop && isCollapsed}
          toggleSider={toggleSider}
        />

        <S.SiderContent>{renderContent()}</S.SiderContent>
      </S.Sider>

      {mobileOnly && <Overlay onClick={toggleSider} show={!isCollapsed} />}
    </>
  );
};

export default MainSider;
